module.exports = __webpack_public_path__ + "files/124d21f8fadb8e6da65da3ae66faaba7.png";